import * as React from "react";

const InstallComputerIcon = ({ color = "var(--text-color-card)", width = 24, height = 24 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 16 16">
    <path
      fill={color}
      d="M7.512 1038.362a6.49 6.49 0 0 0-4.068 11.564.5.5 0 0 0 .624-.78 5.483 5.483 0 0 1-1.757-6.112 5.496 5.496 0 0 1 5.199-3.672 5.49 5.49 0 0 1 5.185 3.692 5.484 5.484 0 0 1-1.779 6.105.5.5 0 1 0 .621.783 6.49 6.49 0 0 0-4.025-11.58zm-.02 2.617a.5.5 0 0 0-.492.506v4.864l-1.268-1.268a.5.5 0 0 0-.359-.15.5.5 0 0 0-.348.857l2.079 2.078a.5.5 0 0 0 .796 0l2.075-2.074a.5.5 0 1 0-.707-.707L8 1046.353v-4.864a.5.5 0 0 0-.508-.506zm-1.892 8.084a.5.5 0 1 0 0 1h3.8a.5.5 0 1 0 0-1H5.6z"
      transform="translate(0 -1036.362)"
    />
  </svg>

  //   <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 1024 1024">
  //     <path
  //       d="M512 64a448 448 0 1 1 0 896.064A448 448 0 0 1 512 64zm67.2 275.072c33.28 0 60.288-23.104 60.288-57.344s-27.072-57.344-60.288-57.344c-33.28 0-60.16 23.104-60.16 57.344s26.88 57.344 60.16 57.344zM590.912 699.2c0-6.848 2.368-24.64 1.024-34.752l-52.608 60.544c-10.88 11.456-24.512 19.392-30.912 17.28a12.992 12.992 0 0 1-8.256-14.72l87.68-276.992c7.168-35.136-12.544-67.2-54.336-71.296-44.096 0-108.992 44.736-148.48 101.504 0 6.784-1.28 23.68.064 33.792l52.544-60.608c10.88-11.328 23.552-19.328 29.952-17.152a12.8 12.8 0 0 1 7.808 16.128L388.48 728.576c-10.048 32.256 8.96 63.872 55.04 71.04 67.84 0 107.904-43.648 147.456-100.416z"
  //       fill={color || "var(--text-color-card)"}
  //     />
  //   </svg>
);
export default InstallComputerIcon;
